import React, { useState } from 'react';
import Flex from './Flex';
import { Form, Button, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

const TablePagination = ({
    pageCount,
    handlePageClick,
    pageSize,
    handlePageSizeChange,
    previousClick,
    nextClick,
    isDisablePrevious,
    isDisableNext,
    pageIndex,
    module
}) => {

    const [rowsPerPage, setRowsPerPage] = useState([5, 10, 20, 30, 40])
    const [rowsPerPage1, setRowsPerPage1] = useState([15, 30, 45, 60])

    return (
        <>
            <Flex alignItems="center" justifyContent="center" className="pagination-page" >
                <Form.Label column className='col-auto'>
                    Rows per page&nbsp;
                </Form.Label>
                <Col sm="2" className='pagination-col-1' >
                    <Form.Select
                        size="sm"
                        className="w-auto"
                        onChange={handlePageSizeChange}
                        defaultValue={pageSize}
                    >
                        
                        {module != "CustomerInquiry" && rowsPerPage.map(value => (
                            <option value={value} key={value}>
                                {value}
                            </option>
                        ))}
                            {module == "CustomerInquiry" && rowsPerPage1.map(value => (
                            <option value={value} key={value}>
                                {value}
                            </option>
                        ))}
                    </Form.Select>
                </Col>

                <Col column className="pagination-col-2" >
                    {
                        pageCount > 0 &&
                        <>
                            <Flex className="ms-5">
                                <Button
                                    size="lg"
                                    variant="falcon-default"
                                    className={classNames({ disabled: isDisablePrevious })}
                                    onClick={previousClick}
                                >
                                    <FontAwesomeIcon icon="chevron-left" className='fav-icon'/>
                                </Button>

                                <ul className="pagination mb-0 mx-1">
                                    {Array.from(Array(pageCount).keys()).slice(
                                        Math.floor(pageIndex / 5) * 5,
                                        Math.floor(pageIndex / 5) * 5 + 5
                                    ).map((page, index) => (
                                        <li key={page} className={classNames({ active: pageIndex == page })}>
                                            <Button
                                                size="lg"
                                                variant="falcon-default"
                                                className={classNames('page', {
                                                    'me-1': index + 1 !== pageCount
                                                })}
                                                onClick={() => handlePageClick({ selected: page })}
                                            >
                                            <span className='page-number-box'>    {page + 1}</span>
                                            </Button>
                                        </li>
                                    ))}
                                </ul>

                                <Button
                                    size="lg"
                                    variant="falcon-default"
                                    onClick={nextClick}
                                    className={classNames({ disabled: isDisableNext })}
                                >
                                    <FontAwesomeIcon icon="chevron-right" className='fav-icon'/>
                                </Button>
                            </Flex>
                        </>
                    }
                </Col>
            </Flex >
        </>
    )
}

export default TablePagination